import { types } from "../../types/types";

const initialState = {
  activeStep: 0,
  afiliadoSeleccionado: null,
  showForm: true,
  items: [],
  certificadoSeleccionado: []
};

export const CertificadoAtencionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.certificadoAtencionClearReducer:
      return {
        ...initialState,
      };
    case types.certificadoAtencionSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.certificadoAtencionSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.certificadoAtencionCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      }
    case types.certificadoAtencionUpdateAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.certificadoAtencionSetShowForm:
      return {
        ...state,
        showForm: action.payload,
      };
    case types.certificadosAtencionSucess:
      return {
        ...state,
        items: action.payload,
      };
    case types.setCertificadoAtencionSeleccionado:
      return {
        ...state,
        certificadoSeleccionado: action.payload,
      };
    default:
      return state;
  }
};
